import { render } from "./MessengerFloat.vue?vue&type=template&id=dfc63420&scoped=true"
import script from "./MessengerFloat.vue?vue&type=script&lang=js"
export * from "./MessengerFloat.vue?vue&type=script&lang=js"

import "./MessengerFloat.vue?vue&type=style&index=0&id=dfc63420&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfc63420"]])

export default __exports__